<div class="car-detail-electro-stats__item">
  {{ label }}
  <div class="car-detail-electro-stats__item-value">
    <ng-content></ng-content>
  </div>
</div>
